export const ENQUEUE_SNACKBAR = 'SNACKBAR/ENQUEUE';
export const REMOVE_SNACKBAR = 'SNACKBAR/REMOVE';